import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  actionIndicator: {
    height: pxToRem(20),
    textAlign: 'center',
    fontSize: pxToRem(20),
    color: theme.palette.red,
    paddingTop: pxToRem(3),
    selectors: {
      '& .ms-Icon': {
        fontSize: pxToRem(18),
        position: 'absolute',
        right: pxToRem(21),
      },
    },
  },
  iconColumn: {
    fontSize: pxToRem(18),
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    paddingLeft: pxToRem(8),
    paddingTop: pxToRem(3),
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: pxToRem(16),
    verticalAlign: 'middle',
    marginLeft: pxToRem(6),
    color: theme.palette.neutralPrimary,
  },
  uploadingSpinner: {
    selectors: {
      '& .ms-Spinner--xSmall': {
        borderWidth: pxToRem(1),
        marginTop: pxToRem(1),
      },
    },
  },
  staticSpinner: {
    paddingTop: pxToRem(3),
    selectors: {
      '& .ms-Spinner-circle': {
        animation: 'none',
        border: `solid ${pxToRem(0.5)} ${theme.palette.velvet}`,
        marginTop: pxToRem(0),
        width: pxToRem(12),
        height: pxToRem(12),
      },
    },
  },
  buttonColumn: {
    textAlign: 'right',
  },
  filenameField: {
    paddingRight: `${pxToRem(50)} !important`,
  },
  button: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    selectors: {
      span: {
        fontWeight: 400,
      },
      a: {
        selectors: {
          '&:hover': {
            textDecoration: 'none',
          },
        },
      },
    },
  },
  rightIcon: {
    verticalAlign: 'middle',
    marginLeft: pxToRem(7),
    fontSize: pxToRem(14),
  },
  overflowable: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingRight: pxToRem(10),
  },
});
